import { Button, Form, Input, Space, Switch } from "antd";

export function AddEditVideoForm({ loading, form, onCancel, onSubmit }) {
  function handleSubmit(values) {
    onSubmit?.(values);
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      autoComplete="off"
    >
      <Form.Item
        label="Hoạt động"
        name="isActive"
        valuePropName="checked"
        initialValue={true}
      >
        <Switch disabled={loading} size="large" />
      </Form.Item>

      <Form.Item
        label="Tiêu đề"
        name="title"
        rules={[
          { required: true, message: "Vui lòng nhập tiêu đề!" },
          { min: 2, max: 200, message: "Tiêu đề phải từ 2 đến 200 ký tự!" },
        ]}
      >
        <Input
          disabled={loading}
          placeholder="Nhập tiêu đề video"
          size="large"
        />
      </Form.Item>

      <Form.Item
        label="URL YouTube"
        name="url"
        rules={[
          { required: true, message: "Vui lòng nhập URL YouTube!" },
          {
            pattern:
              /^https?:\/\/(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)/,
            message: "URL YouTube không hợp lệ!",
          },
        ]}
      >
        <Input
          disabled={loading}
          placeholder="Ví dụ: https://www.youtube.com/watch?v=VIDEO_ID"
          size="large"
        />
      </Form.Item>

      <Form.Item>
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            loading={loading}
            block
            onClick={onCancel}
            size="large"
          >
            Hủy
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            size="large"
          >
            Lưu
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
